import { TGetEnumOptionReqDto, TGetEnumOptionsResDto } from "@/api/services/global/enum/dtos/get-enum-options.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { valueOf } from "@/types/common";
import { globalApi } from "@/utils/api";
import { createUrlWithParams } from "@/utils/url";
import { useQuery } from "@tanstack/react-query";

export type TEnumName = valueOf<
  [
    "EUserType",
    "EAdminRole",
    "ERSOContractStatus",
    "EOrganizationContractStatus",
    "EOrganizationUserRole",
    "EInformationType",
    "EUserActiveStatus",
    "EEmploymentStatus",
    "ERetirementStatus",
    "EDocumentType",
    "EDocumentKey",
    "EDocumentStepKey",
    "EDocumentStatus",
    "ESubmitStatus",
    "EQuarter",
    "EEmployeeResidencePeriod",
    "EEmployeeResidenceStatus",
    "EEmployeeContractMainOccupation",
    "ESupportImplementationStatus",
    "EProvince",
    "EGender",
    "EEmployeeTrainingStatus",
    "EEmployeeCareerCompletionProof",
    "EEmployeeCareerSkillCertificationOne",
    "EEmployeeCareerSkillExamOne",
    "EEmployeeCareerLocation",
    "EEmployeeCareerJapaneseCertification",
    "EEmployeeCareerJapaneseExam",
    "EConvertStatus",
    "EConvertError",
    "ECompanySpecificIndustry",
    "EMaintenanceMode",
    "EConvertDocumentName",
    "EEmploymentContractModificationType",
    "EModifyContractTerminateReason",
    "EModifyContractTerminateReasonForEmployee",
    "EModifyContractTerminateReasonForCompany",
    "EModifyContractModificationReason",
    "EModifyContractChangeDispatchLocationReasons",
    "ESupportRegistered",
    "ESupportRecipient",
    "ETerminateContractMajorCategoryReason",
    "ETerminateContractSubcategoryReason",
    "ESupportContractSubcategoryReason",
    "ESupportSpecifiedSkill",
    "ESupportOutsourcingContractModificationType",
    "ERetirementReasonType",
    "EModifyContractTerminateReasonForEmployee",
    "ECurrentSituation",
    "EPlanToContinueActivity",
    "EMeasure",
    "ESpecificCircumstance",
    "ESpecificCircumstanceContent",
    "EAnyConsultation",
    "EAnyConsultationContent",
    "EPlanToChangeJob",
    "EPlanToChangeJobContent",
    "ESupportType",
    "ESupportContent",
    "EReasonReturnHome",
    "EReasonReturnHomeContent",
    "EPlanDateReturn",
    "EPlanDateReturnContent",
    "EPlanToMove",
    "EPlanToMoveContent",
    "EProvidedLegalProtection",
    "EPartType",
    "ETaxCategory",
    "EInvoiceDisplayFormat",
    "EBillingCycle",
  ]
>;

export const fetchEnumApi = async (enumName: TEnumName, req?: TGetEnumOptionReqDto): Promise<TGetEnumOptionsResDto> => {
  const url = createUrlWithParams(`/enums/${enumName}/options`, req);
  const rs = await globalApi.get<TGetEnumOptionsResDto>(url);
  return rs.data;
};

export const useEnum = (enumName?: TEnumName, req?: TGetEnumOptionReqDto) => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.FETCH_ENUM, enumName, req?.lang],
    queryFn: () => (enumName ? fetchEnumApi(enumName, req) : undefined),
    enabled: Boolean(enumName),
  });

  return { data: data?.data ?? [], ...rest };
};
